'use strict';

/**
 *  TimeRanges to string helper
 */

var TimeRanges = {
  toString: function toString(r) {
    var log = '',
        len = r.length;
    for (var i = 0; i < len; i++) {
      log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
    }
    return log;
  }
};

module.exports = TimeRanges;


//////////////////
// WEBPACK FOOTER
// ./~/hls.js/lib/utils/timeRanges.js
// module id = 609
// module chunks = 0 1 2 3